<div class="page-header-container">
  <div class="page-title">
    {{'users.title' | translate}}
  </div>
</div>

<div class="header-buttons-box">
  <div class="custom-text-input-container search-container flex-grow-1">
    <kendo-autocomplete HJSuppress
      [rounded]="roundedLarge"
      [data]="autocompleteDatasource"
      [filterable]="true"
      [valueField]="'name'"
      [placeholder]="'users.companySearchPlaceholder' | translate"
      [clearButton]="false"
      [(ngModel)]="autocompleteValue.value"
      (ngModelChange)="companySelectedHandler($event)"
      (filterChange)="filterDataSource($event)"
    >
      <ng-template kendoPrefixTemplate>
        <i class="app-icon icon icon-search icon-xl2"></i>
      </ng-template>
      <ng-template kendoAutoCompleteItemTemplate let-dataItem>
        <div HJSuppress class="autocomplete-template-container fw-semibold">
          <span class="autocomplete-main-label">{{dataItem?.name}}</span>
          <span class="autocomplete-second-label text-secondary" *ngIf="dataItem.uniqueIdentifier">
            {{'users.cui' | translate}}: {{dataItem?.uniqueIdentifier}}
          </span>
          <span class="autocomplete-second-label text-secondary" *ngIf="!dataItem.uniqueIdentifier">
            {{'users.code' | translate}}: {{dataItem?.code}}
          </span>
        </div>
      </ng-template>

      <ng-template kendoAutoCompleteNoDataTemplate>
        <span *ngIf="partnerSearchValue?.length < 3">{{'users.searchPartnerInfo' | translate}}</span>
        <span *ngIf="partnerSearchValue?.length >= 3 && !hasPartners">{{'common.noData' | translate}}</span>
      </ng-template>
    </kendo-autocomplete>
  </div>
</div>

<div class="company-list-container">
  <div class="d-flex flex-column justify-content-center align-items-center flex-grow-1 mx-3 my-5 m-lg-0"
        *ngIf="!isCompanySelected">
    <h3 class="text-secondary mb-3">{{'users.noCompanySelected' | translate}}</h3>
    <no-records-placeholder></no-records-placeholder>
  </div>

  <div class="company-selected-container" *ngIf="isCompanySelected">
    <div *ngIf="hasData">
      <div class="page-header-container mt-5">
        <div class="user-list-title">
          <span class="me-2">{{'users.listTitle' | translate}}</span>
          <span HJSuppress class="text-primary fw-bold">{{autocompleteValue?.value}}</span>
        </div>

        <div class="header-buttons-box">
          <div class="buttons-group-box table-view-mode-switch d-none d-lg-flex">
            <div class="btn-group" role="group">
              <button class="btn white-btn" (click)="toggleViewMode(TABLE_VIEW_MODES.LIST_VIEW)"
                      [disabled]="tableViewMode === TABLE_VIEW_MODES.LIST_VIEW">
                <i class="app-icon icon icon-view-list icon-lg me-2"></i>
                <span>{{ "common.listView" | translate }}</span>
              </button>

              <button class="btn white-btn" (click)="toggleViewMode(TABLE_VIEW_MODES.CARDS_VIEW)"
                      [disabled]="tableViewMode === TABLE_VIEW_MODES.CARDS_VIEW">
                <i class="app-icon icon icon-view-grid icon-lg me-2"></i>
                <span>{{ "common.cardsView" | translate }}</span>
              </button>
            </div>
          </div>

          <button class="btn primary-btn" (click)="navigateAddEditFormHandler(selectedPartnerTenantId)">
            <i class="app-icon icon icon-add icon-xl me-2"></i>
            {{'users.addUserBtn2' | translate}}
          </button>
        </div>
      </div>

      <users-list-view
        *ngIf="(tableViewMode === TABLE_VIEW_MODES.LIST_VIEW && windowSizeLgUp)"
        [users]="users"
        [props]="usersProps"
        [viewDetails]="viewDetailsHandler"
        [deleteUser]="deleteUserHandler"
        [changeUserStatus]="userStatusHandler"
        [redirectUserDetails]="redirectUserDetails"
        [redirectUserRights]="redirectUserRights">
      </users-list-view>

      <users-card-view *ngIf="tableViewMode === TABLE_VIEW_MODES.CARDS_VIEW || !windowSizeLgUp"
        [users]="users"
        [props]="usersProps"
        [viewDetails]="viewDetailsHandler"
        [deleteUser]="deleteUserHandler"
        [changeUserStatus]="userStatusHandler"
        [redirectUserDetails]="redirectUserDetails"
        [redirectUserRights]="redirectUserRights">
      </users-card-view>
    </div>

    <div *ngIf="!hasData" 
      class="d-flex flex-column justify-content-center align-items-center flex-grow-1 mx-3 my-5 m-lg-0 gap-3">
      <h3 class="text-secondary">
        {{'users.noUsers' | translate}} <span class="fw-bold">{{autocompleteValue?.value}}</span>!
      </h3>
      <div class="d-flex justify-content-center">
        <button class="btn primary-btn px-5" (click)="navigateAddEditFormHandler(selectedPartnerTenantId)">
          {{'users.addUserBtn' | translate}}
        </button>
      </div>
      <add-user-placeholder></add-user-placeholder>
    </div>
  </div>
</div>
